import React from 'react';
import CommonBanner from '../component/Common/CommonBanner';
// import './Forms.css'; // Optional: for shared form styles

const SupportFormPage = () => {
    return (
        <>
            <CommonBanner heading="Get Support" pagination="Support" />
            <section className="who_we_are_section section_padding">
                <div className="container">
                    <div className="who_we_are_img">
             <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSelww1y9Ha1NbY_z8ZFu2TT2mQqkE466jw0-9Q5Tl0rwxIwsw/viewform?embedded=true" width="100%" height="3654" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
                    </div>
                </div>
            </section>
        </>
    );
};

export default SupportFormPage;
